/*
 * Define a form page allowing the user to enter the activity end date.
 */
import css from './pages.module.css'
import { approxDateMessage } from '../validators/dateYup'
import { datePage } from './datePage'

export const activityEndDatePage = propOverrides => {
  const props = {
    pageId: 'activity_end_date_page',
    fieldName: 'activity_end_date',
    required: true,
    label: 'When did the activity end?',
    hint: approxDateMessage,
    labelClassName: css.largeDateLabel,
    ...propOverrides
  }

  return datePage({ ...props })
}
